import {notification} from "antd";
import {COMMON_ROUTER} from "../constants";

let websocket, lockReconnect = false;
let createWebSocket = (propsHistory, url) => {
    // console.log(url + ',公共websocket 建立连接...')
    websocket = new WebSocket(url);
    websocket.onopen = function () {
        heartCheck.reset().start();
    }
    websocket.onerror = function () {
        lockReconnect = false;
        reconnect(propsHistory, url);
    };
    websocket.onclose = function (e) {
        // console.log('公共websocket 断开: ' + e.code + ',' + e.reason + ',' + e.wasClean)
        lockReconnect = false;
        if (e.code === 1000) {
            // console.log('公共websocket 主动断开')
        } else {
            reconnect(propsHistory, url);
        }
    }
    websocket.onmessage = function (event) {
        // console.log(event)
        console.log(event.data)
        if(event.data === 'HeartBeat'){
            // console.log('公共websocket 心跳包')
        } else {
            let data = JSON.parse(event.data)
            if (data.dataType === 0) {
                lockReconnect = true;
            } else if (data.dataType === 1) {
                openNotification(propsHistory,'新订单', 1, data.mainShop, data.tag)
            } else if (data.dataType === 2) {
                openNotification(propsHistory,'预订单提醒', 2, data.mainShop, data.tag)
            } else if (data.dataType === 3) {
                openNotification(propsHistory,'配送异常', 3, data.mainShop, data.tag)
            } else if (data.dataType === 4) {
                openNotification(propsHistory,'索赔', 4, data.mainShop, data.tag)
            } else if (data.dataType === 5) {
                openNotification(propsHistory,'催单', 5, data.mainShop, data.tag)
            } else if (data.dataType === 6) {
                openNotification(propsHistory,'取消单', 6, data.mainShop, data.tag)
            } else if (data.dataType === 7) {
                openNotification(propsHistory,'退单', 7, data.mainShop, data.tag)
            }
            saveWebSocketMsg(data.dataType, data.mainShop)
        }
    }
}
let reconnect = (propsHistory, url) => {
    if (lockReconnect) return;
    //没连接上会一直重连，设置延迟避免请求过多
    setTimeout(function () {
        createWebSocket(propsHistory, url);
        lockReconnect = false;
    }, 20000);
}
let heartCheck = {
    timeout: 60000, //60秒
    timeoutObj: null,
    reset: function () {
        clearInterval(this.timeoutObj);
        return this;
    },
    start: function () {
        this.timeoutObj = setInterval(function () {
            //这里发送一个心跳，后端收到后，返回一个心跳消息，
            websocket.send("HeartBeat");
        }, this.timeout)
    }
}
//关闭连接
let closeWebSocket=()=> {
    // console.log('公共websocket closeWebSocket')
    websocket && websocket.close();
}

let openNotification = (propsHistory, desc, type, templateId, tag) => {
    notification.open({
        key: tag,
        message: '消息提醒',
        description:desc,
        duration: 0,
        onClick: () => {
            propsHistory.push({
                pathname : COMMON_ROUTER + '/order',
                state :{
                    templateId:templateId,
                    selectedType: type,
                }
            });
            notification.close(tag)
        },
    });
};
let saveWebSocketMsg= (type, templateId) => {
    if (!window.localStorage) {
        alert('浏览器不支持localstorage');
        return false;
    } else {
        var storage = window.localStorage;
        storage.setItem('templateId', templateId)
        storage.setItem('selectedType', type)
        if (storage.getItem('templateId')) {
            // console.log('templateId已存储')
        }
        if (storage.getItem('selectedType')) {
            // console.log('selectedType已存储')
        }
    }
}
export {
    websocket,
    createWebSocket,
    closeWebSocket,
    reconnect
};


// WEBPACK FOOTER //
// ./src/utils/websocket.js